var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.content},[_c('ContactForm'),_vm._v(" "),_c('TextBlock',{attrs:{"content":_vm.content.text,"title":_vm.content.title}}),_vm._v(" "),_c('ul',_vm._l((_vm.content.list),function(item){return _c('li',{key:item,attrs:{"data-anim":"stagger"},domProps:{"innerHTML":_vm._s(item)}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e6bc611","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobList.vue
// module id = null
// module chunks = 